module.exports = __webpack_public_path__ + "static/media/icon-visibility-app-connection.6e03e14e.svg";